import { Control } from "../Control.js";

export class Heading extends Control {

    constructor(parent, params = {}) {

        params = Object.assign({
            text: 'Heading',
            level: 1
        }, params || {});

        super(parent, params);

        const {
            text = 'Heading',
            level = 1,
        } = params;

        this.text = text;
        this.level = level;

    };

    getText() {

        return (typeof this.text === 'function') ? this.text.call(this) : this.text;

    };

    getLevel() {

        return (typeof this.level === 'function') ? this.level.call(this) : this.level;

    };

    _render(r, vm) {

        if (!this.isVisible())
            return null;

        const renderer = r;

        var props = {},
            style = this.getCss() || '';

        return renderer.heading(this.getLevel(), this.getText(), { css: style, props });

    };

}